import * as React from 'react';

import { useQuery } from '@apollo/client';
import { useRecommendationsExplainerEnabled } from '@coursera-web/recommendations-common';
import { StatsigProvider } from '@coursera-web/statsig';

import StoreProviderWrapper from 'bundles/ai-coach-platform/components/patterns/chat/store/StoreProviderWrapper';
import SearchBarContentWrapper from 'bundles/search-common/components/searchbar/SearchBarContentWrapper';
import SearchBarRecommendationsQuery from 'bundles/search-common/queries/SearchBarRecommendations.graphql';
import type {
  SearchBarRecommendationsQuery as SearchBarRecommendationsQueryData,
  SearchBarRecommendationsQueryVariables,
} from 'bundles/search-common/queries/__generated__/SearchBarRecommendations';
import { getItemsListFromLocalStorageByKeyAndTrimOutdated } from 'bundles/search-common/utils/SearchUtils';

type Props = {
  autocompleteId?: string;
  hideSearch?: boolean;
  searchIsOpen?: boolean;
  hideMobileSearchPage?: () => void;
  isChatComposer?: boolean;
  placeholder?: string;
};

const SearchBar = ({
  autocompleteId,
  searchIsOpen,
  hideMobileSearchPage,
  hideSearch,
  isChatComposer,
  placeholder,
}: Props) => {
  const explainerEnabled = useRecommendationsExplainerEnabled();
  const localRecentlyViewedCount = getItemsListFromLocalStorageByKeyAndTrimOutdated('recently-viewed').length;
  // Still fetch when the explainer is on so Recently viewed can show collection metadata even with 4+ local items.
  const { data } = useQuery<SearchBarRecommendationsQueryData, SearchBarRecommendationsQueryVariables>(
    SearchBarRecommendationsQuery,
    {
      variables: { queryCollectionId: 'recently-viewed-products', limit: 4 },
      skip: !explainerEnabled && localRecentlyViewedCount >= 4,
      context: { clientName: 'gatewayGql' },
      ssr: false,
    }
  );
  const collectionRecommendations = data?.Recommendations?.queryCollection;

  if (hideSearch) return null;

  return (
    <StatsigProvider>
      <StoreProviderWrapper>
        <SearchBarContentWrapper
          autocompleteId={autocompleteId}
          collectionRecommendations={collectionRecommendations}
          searchIsOpen={searchIsOpen}
          hideMobileSearchPage={hideMobileSearchPage}
          searchBarConfig={{}}
          isChatComposer={isChatComposer}
          placeholder={placeholder}
        />
      </StoreProviderWrapper>
    </StatsigProvider>
  );
};

export default SearchBar;
